import { render, staticRenderFns } from "./voteQrCode.vue?vue&type=template&id=e1fa2720&scoped=true"
import script from "./voteQrCode.vue?vue&type=script&lang=js"
export * from "./voteQrCode.vue?vue&type=script&lang=js"
import style0 from "./voteQrCode.vue?vue&type=style&index=0&id=e1fa2720&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1fa2720",
  null
  
)

export default component.exports